import { render, staticRenderFns } from "./personalAssistantBuilderMobile.vue?vue&type=template&id=e4ad3dd4&scoped=true"
import script from "./personalAssistantBuilderMobile.vue?vue&type=script&lang=js"
export * from "./personalAssistantBuilderMobile.vue?vue&type=script&lang=js"
import style0 from "./personalAssistantBuilderMobile.vue?vue&type=style&index=0&id=e4ad3dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ad3dd4",
  null
  
)

export default component.exports